export const PRODUCT_TITLE_MAX_LENGTH = 80;
export const PRODUCT_DESCRIPTION_MAX_LENGTH = 2000;
export const PRODUCT_PRICE_MAX = 9_999_999;
export const PRODUCT_LOCATION_RADIUS_METERS = 2000;
export const PRODUCT_LOCATION_MAP_ZOOM = 12;
// The OpenStreetMap data licence requires this credit wherever its tiles are shown.
export const MAP_TILE_ATTRIBUTION =
  '&copy; <a href="https://www.openstreetmap.org/copyright" target="_blank" rel="noopener noreferrer">OpenStreetMap</a> contributors';
export const PRODUCT_LOCATION_MAP_MOBILE_ZOOM = 12.1;
